<template>
    <div style="display:contents;">
        <div class="table-td">
            <span v-if="full_name">{{ full_name }} - </span>
            {{ member.email }}
        </div>
        <div class="table-td" v-text="member.role_name"></div>
        <div class="table-td">
            <div class="table-label p-l-0 p-r-0" style="width: 65px;" :class="label_class">
                {{ member.status }}
            </div>
        </div>
        <div class="table-td text-align-right">
            <div v-if="has_actions">
                <a class="button button-line button-tiny button-icon" v-on:click="toggleDropDown"> <v-icon name="chevron-down"></v-icon>Actions</a>
                <DropDownMenu class="right dropdown-menu-td" :active="member.actions_active" v-click-outside="toggleDropDown">
                    <ul>
                        <li>
                            <a v-if="can_invite" v-on:click="openConfirmResendInvitationModal">
                                <div class="menu-icon"><v-icon name="send"></v-icon></div>
                                <div class="menu-label">Resend invitation</div>
                            </a>

                            <a v-if="can_update_role" v-on:click="openChangeRoleModal">
                                <div class="menu-icon"><v-icon name="shield"></v-icon></div>
                                <div class="menu-label">Change role</div>
                            </a>

                            <a v-if="can('remove-from-project')" v-on:click="deleteMember">
                                <div class="menu-icon"><v-icon name="trash"></v-icon></div>
                                <div class="menu-label">Delete member</div>
                            </a>
                        </li>
                    </ul>
                </DropDownMenu>
            </div>
        </div>

    </div>
</template>

<script>
import Event from '@/libraries/eventbus.js'

import DropDownMenu from '@/components/DropDownMenu.vue'
import Modal from '@/models/Modal.js'
import Project from '@/models/Project.js'
import Invitation from '@/models/Invitation.js'

export default {
    props: ['project', 'member'],
    computed: {
        full_name: function () {
            if(!this.member.firstname && !this.member.lastname) return null
            const name = (this.member.firstname + ' ' + this.member.lastname).trim()
            return name ? name : ''
        },
        has_actions: function () {
            return this.can_invite || this.can('remove-from-project')
        },
        can_update_role: function () {
            return this.can('remove-from-project') && this.project.available_roles.length > 1
        },
        can_invite: function () {
            return this.can('invite-to-project') && this.member.status != 'accepted'
        },
        label_class: function () {
            switch(this.member.status) {
                case 'accepted': return 'table-label-success'
                case 'declined': return 'table-label-danger'
            }

            return ''
        }
    },
    methods: {
        toggleDropDown: function () {
            this.$emit('toggle-dropdown', this.member.id)
        },
        openConfirmResendInvitationModal: function() {

            const params = {
                'project_id': this.project.id,
                'user_id': this.member.id
            }

            this.$emit('toggle-dropdown', false)

            this.$confirm({
                message: 'Do you want to send another invitation to this member?',
                button: {
                    no: 'No',
                    yes: 'Yes'
                },
                callback: confirm => {
                    if (confirm) {
                        Invitation.dispatch('reinviteToProject', params).then(response => {
                            if (response.success) {
                                Event.dispatch('project_user.reinvited', params)
                            } else {
                                Event.dispatch('project_user.errors', response.data.errors)
                            }
                        })
                    }
                }
            })
        },
        openChangeRoleModal: function() {
            Modal.dispatch('launch', {
                type: 'member.change_role',
                name: 'Change member role',
                variant: 'small',
                data: {
                    type: 'project',
                    project_id: this.project.id,
                    member: this.member,
                    available_roles: this.project.available_roles
                }
            })
        },
        deleteMember: function () {
            const params = {
                'id': this.project.id,
                'user_id': this.member.id
            }

            this.$emit('toggle-dropdown', false)

            this.$confirm({
                message: 'Are you sure you want to delete this member?',
                button: {
                    no: 'Keep',
                    yes: 'Remove'
                },
                callback: confirm => {
                    if (confirm) {
                        Project.dispatch('removeUser', params).then(response => {
                            if (response.success) {
                                Event.dispatch('project_user.deleted', params)
                            } else {
                                Event.dispatch('project_user.errors', response.data.errors)
                            }
                        })
                    }
                }
            })
        }
    },
    components: {
        DropDownMenu
    }

}
</script>